import { gql } from 'apollo-angular';
import { Notification } from '../../entities/notification/notification';

// #736: In-App-Notification-Stream (Glocke). Alle Operationen sind selbst-scoped (der Server
// bezieht sie auf den aufrufenden Nutzer) — es wird bewusst keine userId uebergeben.

export interface NotificationPage {
  items: Notification[];
  nextCursor: string | null;
}

export interface NotificationsPageResponse {
  getMyNotificationsPage: NotificationPage;
}

export interface UnreadCountResponse {
  getMyUnreadNotificationsCount: number;
}

export interface MarkReadResponse {
  markNotificationRead: boolean;
}

export interface MarkAllReadResponse {
  markAllNotificationsRead: number;
}

/** notificationCatalog.graphqls: enum NotificationChannelKey { IN_APP EMAIL PUSH } */
export type NotificationChannelKey = 'IN_APP' | 'EMAIL' | 'PUSH';

export interface NotificationOpenedResponse {
  notificationOpened: boolean;
}

export interface DeleteNotificationResponse {
  deleteNotification: boolean;
}

export interface DashboardAnnouncementsResponse {
  getMyDashboardAnnouncements: Notification[];
}

export const NOTIFICATION_FIELDS = `
  id
  typeKey
  title
  body
  bodyRich
  correctsAnnouncementId
  deepLink {
    type
    id
  }
  uriLink
  sticky
  groupKey
  readAt
  createdAt
`;

export const NOTIFICATIONS_PAGE_QUERY = gql`
  query getMyNotificationsPage($cursor: ID, $limit: Int!, $unreadOnly: Boolean!) {
    getMyNotificationsPage(cursor: $cursor, limit: $limit, unreadOnly: $unreadOnly) {
      items {
        ${NOTIFICATION_FIELDS}
      }
      nextCursor
    }
  }
`;

export const UNREAD_COUNT_QUERY = gql`
  query getMyUnreadNotificationsCount {
    getMyUnreadNotificationsCount
  }
`;

export const MARK_NOTIFICATION_READ_MUTATION = gql`
  mutation markNotificationRead($id: ID!) {
    markNotificationRead(id: $id)
  }
`;

export const MARK_ALL_NOTIFICATIONS_READ_MUTATION = gql`
  mutation markAllNotificationsRead {
    markAllNotificationsRead
  }
`;

export const NOTIFICATION_OPENED_MUTATION = gql`
  mutation notificationOpened($id: ID!, $channel: NotificationChannelKey!) {
    notificationOpened(id: $id, channel: $channel)
  }
`;

export const DELETE_NOTIFICATION_MUTATION = gql`
  mutation deleteNotification($id: ID!) {
    deleteNotification(id: $id)
  }
`;

/**
 * Dieselben Felder wie NOTIFICATIONS_PAGE_QUERY (NOTIFICATION_FIELDS) — die Zeile auf dem Dashboard
 * ist app-notification, dieselbe Komponente wie im Stream, und braucht deshalb denselben Feldsatz
 * (u. a. readAt fuer den Lesezustand, deepLink/uriLink fuer den Aktionsknopf der Fusszeile).
 */
export const DASHBOARD_ANNOUNCEMENTS_QUERY = gql`
  query getMyDashboardAnnouncements {
    getMyDashboardAnnouncements {
      ${NOTIFICATION_FIELDS}
    }
  }
`;
